










import Vue from 'vue';
import debounce from 'lodash/debounce';

export default Vue.extend({
  name: 'HubSlider',

  inheritAttrs: false,

  props: {
    value: {
      type: Number,
      required: true,
    },
  },

  computed: {
    sliderValue: {
      get() { return (this as any).value; },
      set: debounce(
        function fn(this: Vue, newSliderValue: number) {
          this.$emit('input', newSliderValue);
        }, 300,
      ),
    },
  },
});
